import React from 'react';
import { withRouter } from 'react-router-dom';
import PrivacyInfo from "../../PrivacyInfo/PrivacyInfo";

export class PrivacyPage extends React.Component {
  render() {
    return (
      <div
        id="page-container"
        className="row align-items-center justify-content-center">
        <div className="col-lg-6">
          <PrivacyInfo showClose={false}/>
        </div>
      </div>
    );
  }
}

export default withRouter(PrivacyPage);


// WEBPACK FOOTER //
// ./src/components/pages/PrivacyPage/PrivacyPage.jsx